<template>
    <div class="main-background">
          <div class="main-image-container">
            <img :src=" openedProduct.img" alt="" class="main-image">
            <div class="product-name-container">
                <p class="product-info-name">{{ openedProduct.name }}</p>
                <div class="stars-counter-line-container">
                   <p class="stars-counter">9,473 stars</p>
                   <p class="stars-raiting">
                    <star-icon class="stars-raiting-icon"/>
                    {{ openedProduct.rating }} - CDN - рекомендує
                   </p>
                </div>
                <button @click="toogleWishList()" class="add-to-wich-button">{{isIncludeOnWish ? 'Проєкт доданий в Ваш список' : 'Додати в мій список'}}</button>
            </div>
           
          </div>
          <div class="product-info-container">
            <p class="product-info-title">Опис проекту</p>
            <p v-if="openedProduct.description.length > 100" class="product-info">
                {{ isShowAllDescription ? openedProduct.description : openedProduct.description.substring(0, 100) + '...' }}
                <span class="product-info-span" 
                @click="isShowAllDescription = !isShowAllDescription"
                >{{isShowAllDescription ? 'Сховати' : 'Показати все'}}</span>
            </p>
            <p v-else class="product-info">{{ openedProduct.description }}</p>
            <p class="product-info-title info-title">Інформація</p>
            <div class="product-info-main-item" v-html="formattedText"></div>
            <!-- <p class="product-info-main-item">
                {{ openedProduct.info }}
            </p> -->
            <!-- <ul class="product-info-main-list">
                <li class="product-info-main-item">TIP додатка: <span>ТАP GAME</span></li>
                <li class="product-info-main-item">Дата старта: <span class="product-info-main-item-value">1 січня 2024</span></li>
                <li class="product-info-main-item">Telegram SUBSCRIBE: <span>6 МЛН. +</span></li>
                <li class="product-info-main-item">Коментарій CDN: <span>Робимов, в цього проекту крута технологія, та майбутнє.</span></li>
            </ul> -->
            <p class="product-info-title info-strategy">{{ openedProduct.telegraf_heading }}</p>
            <div class="product-info-backgraund">
            <a :href="openedProduct.telegraf_link" target="_blank" class="product-info-strategy-container">
                <p class="product-info-strategy-title">{{ openedProduct.telegraf_title }}</p>
                <p class="product-info-strategy-text">{{ openedProduct.telegraf_description }}</p>
            </a>
            </div>
 
          </div>
          <div class="bottom-filter-button-container">
            <a :href="openedProduct.bot_link" target="_blank" class="filtration-button" >Перейти в бот.</a>
          </div>
    </div>
</template>

<script>

import { StarIcon } from 'vue-feather-icons'
import { mapMutations } from "vuex";

export default {
    name: "product-page",
    components: {
        StarIcon
    },
    props: {
        perPage: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            productCounter: 1,
            isAddedTocart: false,
            isShowAllDescription: false,
            isIncludeOnWish: false,
            formattedText: ''
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        this.formattedText = this.openedProduct.info.replace(/\r/g, ' ').replace(/\n/g, '<br>');
        let include = this.wishList.find(el => el.id === this.openedProduct.id)
        if (include) {
            this.isIncludeOnWish = true
        } else {
            this.isIncludeOnWish = false
        }
    },
    computed: {
       openedProduct() {
         return this.$store.getters.openedProduct
       },
       wishList() {
        return this.$store.getters.wishList
       }
    },
    methods: {
        ...mapMutations(['addToWishList']),
        toogleWishList() {
            this.addToWishList(this.openedProduct)
            this.isIncludeOnWish = !this.isIncludeOnWish
        },
    },
    watch: {

    }
}
</script>

<style scoped>

.main-background {
    background: #121212;
}

.back-button-icon {
    position: absolute;
}


.back-button-text {
    text-align: center;
}

.main-image-container {
   width: 100%;
}

.main-image {
    width: 100%;
}

.bottom-filter-button-container {
  position: fixed;
  bottom: -2px;
  width: 100%;
  left: 0px;
  background: #1D1D1D;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
}

.filtration-button {
   display: block;
   border-radius: 8px;
   background: #1E7CE9;
   padding: 12px;
   width: 100%;
   border: none;
   color: #FFF;
   text-align: center;
   font-family: "Comfortaa", sans-serif;
   font-size: 18px;
   font-weight: 600;
   line-height: 24px;
   text-decoration: none;
}

.patry-container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    transform: translate(-50%, -50%);
}

.product-name-container {
   padding: 8px 16px; 
}

.product-info-name {
    color: #FFF;
    font-family: "Comfortaa";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; 
}

.stars-counter-line-container {
    display: flex;
    gap: 19px;
    margin-top: 38px;
}

.stars-counter {
    color: #A0A0A0;
    font-family: "Comfortaa", sans-serif;
    font-size: 10px;;
    font-weight: 700;
    line-height: 18px;
}

.stars-raiting {
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px; 
}

.stars-raiting-icon {
    width: 16px;
    height: 16px;
    vertical-align: -3px;
    color: #1E7CE9;
    fill: #1E7CE9;
}

.product-info-container {
    padding: 16px 16px 90px 16px;
}
.product-info-title {
    color: #FFF;
    font-family: "Comfortaa";
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
}

.product-info-title.info-title {
    padding-top: 16px;
    border-top: 1px solid #1D1D1D;
}

.product-info-title.info-strategy {
    margin-top: 16px;
    text-transform: uppercase;
}

.product-info {
    color: #A0A0A0;
    font-family: "Comfortaa", sans-serif;
    font-size: 14px;
    margin-top: 12px;
    margin-bottom: 16px;
    font-weight: 400;
    line-height: 20px;
}

.product-info-span {
    color: #FFF;
    font-family: "Comfortaa", sans-serif;
    font-size: 14px;
    margin-left: 2px;
    font-weight: 600;
    line-height: 20px;
}

.add-cart-bbutton {
    vertical-align: bottom;
}

.product-info-main-list {
  list-style-type: none;
  padding-left: 16px;
  margin-top: 12px;
}

.product-info-main-item {
  position: relative;
  margin-bottom: 10px;
  color: #A0A0A0;
  font-family: "Comfortaa", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 12px;
}

.product-info-main-item-value {
    color: #fff;
}

.product-info-backgraund {
    background: #1D1D1D;
    border-radius: 8px;
    padding: 12px;
    margin-top: 8px;
}

.product-info-strategy-container {
    text-decoration: none;
}

.product-info-strategy-title {
    color: #FFF;
    font-family: 'Comfortaa', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
}

.product-info-strategy-text {
    color: #A0A0A0;
    margin-top: 8px;
    font-family: "Comfortaa", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.add-to-wich-button {
    border-radius: 8px;
    border: 2px solid #1E7CE9;
    padding: 12px;
    margin-top: 17px;
    color: #1E7CE9;
    background: transparent;
    width: 100%;
    text-align: center;
    font-family: "Comfortaa", sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
}

</style>